import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MaterialUrl, MaterialPdfUrl } from '../../utils/api/services/files';
import formatDate from '../../utils/formatDate';
import formatSize from '../../utils/formatFileSize';
import ContentModal from '../../components/Modals/ContentModal';
import { setTrainingMaterialIsDownload } from '../../utils/api/services/statistic';

export default class TrainingListItem extends Component {

  static propTypes = {
    material: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showContentModal: false,
    };
  }

  getType = ({ extension, vimeoVideoLink }) => {
    if (vimeoVideoLink) {
      return 'vimeoVideo';
    }
    switch (extension) {
      case 'pdf':
        return 'pdf';
        break;

      case 'ogg':
      case 'mp4':
        return 'video';
        break;

      default:
        return 'file';
        break;
    }
  };

  onClickHandler = (materialId, type) => {
    if (type === 'video' || type === 'vimeoVideo') {
      this.setState({
        showContentModal: true,
      });
    } else {
      this.setState({
        showContentModal: false,
      });
    }
    setTrainingMaterialIsDownload(materialId);
  };

  render() {
    const { material } = this.props;
    const { showContentModal } = this.state;
    const type = this.getType({
      extension: material.extension,
      vimeoVideoLink: material.vimeoVideoLink,
    });
    const url = type === 'vimeoVideo' ? material.vimeoVideoLink : MaterialUrl(material.id);
    const pdfUrl = MaterialPdfUrl(material.id);
    const showDownloadButton = type !== 'vimeoVideo';
    return (
      <React.Fragment>
        <div className="list-entries-row">
          {type === 'vimeoVideo' && (
            <Material
              item={material}
              url="javascript:void(0)"
              type={type}
              onClickHandler={this.onClickHandler}
              showDownloadButton={showDownloadButton}
            />
          )}

          {type === 'video' && (
            <Material
              item={material}
              url="javascript:void(0)"
              type={type}
              onClickHandler={this.onClickHandler}
              showDownloadButton={showDownloadButton}
            />
          )}

          {type === 'pdf' && (
            <Material
              item={material}
              url={pdfUrl}
              type={type}
              onClickHandler={this.onClickHandler}
              targetType="_blank"
              showDownloadButton={showDownloadButton}
            />
          )}

          {type === 'file' && (
            <Material
              item={material}
              url={url}
              type={type}
              onClickHandler={this.onClickHandler}
              showDownloadButton={showDownloadButton}
            />
          )}
        </div>
        {showContentModal && (
          <ContentModal
            visible={showContentModal}
            name={material.name}
            src={url}
            extension={material.extension}
            type={type}
            hide={() => {
              this.setState({ showContentModal: false });
            }}
          />
        )}
      </React.Fragment>
    );
  }
}

function Material(props) {
  const {
    item, url, type, onClickHandler, targetType, showDownloadButton,
  } = props;
  return (
    <React.Fragment>
      <div className="list-entries-cell -main">
        <a href={url} target={targetType} onClick={() => onClickHandler(item.id, type)}>
          {item.name}
        </a>
      </div>
      <div className="list-entries-cell -btns">
        {showDownloadButton && (
          <a href={url} target={targetType} onClick={() => onClickHandler(item.id, type)}>
            <i className="icon icon-cloud" />
          </a>
        )}
      </div>
    </React.Fragment>
  );
}
